const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LcawLktAAAAAKtEyUPJoCE3pFjbwzTnEpDIgEA5';

const SCRIPT_ID = 'recaptcha-enterprise-script';

/**
 * Carga el script de Google reCAPTCHA Enterprise dinámicamente si aún no existe en el DOM.
 */
export const loadRecaptchaScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      return resolve();
    }

    if (window.grecaptcha && window.grecaptcha.enterprise) {
      return resolve();
    }

    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', (err) => reject(err));
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = (error) => {
      console.error('Error cargando el script de reCAPTCHA Enterprise:', error);
      reject(error);
    };

    document.head.appendChild(script);
  });
};

/**
 * Oculta la insignia flotante de reCAPTCHA en la esquina inferior si existe.
 */
export const setRecaptchaBadgeVisibility = (visible: boolean) => {
  if (typeof document === 'undefined') return;
  const badge = document.querySelector('.grecaptcha-badge') as HTMLElement | null;
  if (badge) {
    badge.style.visibility = visible ? 'visible' : 'hidden';
  }
};

/**
 * Genera un token de verificación de Google reCAPTCHA Enterprise v3.
 * Carga automáticamente el script si aún no está en el cliente.
 * @param action Identificador de la acción (ej: 'LOGIN', 'RECOVER_PASSWORD')
 * @returns Token cifrado de reCAPTCHA o null si hay algún fallo
 */
export const getRecaptchaToken = async (action: string): Promise<string | null> => {
  try {
    await loadRecaptchaScript();

    return new Promise((resolve) => {
      if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        console.warn('Google reCAPTCHA Enterprise no estuvo listo a tiempo.');
        resolve(null);
        return;
      }

      window.grecaptcha.enterprise.ready(async () => {
        try {
          if (!window.grecaptcha?.enterprise) {
            resolve(null);
            return;
          }
          const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
            action,
          });
          resolve(token);
        } catch (execError) {
          console.error('Error al ejecutar reCAPTCHA Enterprise:', execError);
          resolve(null);
        }
      });
    });
  } catch (error) {
    console.error('Error al obtener token de reCAPTCHA:', error);
    return null;
  }
};
